import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getIcon } from '../../util/icons';

import { withRouter, NavLink } from 'react-router-dom';

import { MessageModal } from '../modals';

import {
  isProduction,
  getDealCompletion,
} from '../../util';

class EmployeeSidebarNav extends Component {

  state = {
    modalMessage: null,
    hoveringNonImperativesPage: false,
    hoveringNonStrengthsPage: false,
  }

  showNoSurveyDataModal(){
    this.setState({
      modalMessage: 'The uncover your strengths survey is coming soon to the new app'
    });
  }

  hideModal(){
    this.setState({
      modalMessage: null
    });
  }

  renderMessageModal(){
    return <MessageModal message={this.state.modalMessage} hide={this.hideModal.bind(this)} visible={this.state.modalMessage} />
  }

  render(){

    //console.log('rendering employee sidebar nav...');
    //console.log('sidebarnav loaded with route params: ', this.props.route);

    const { route, deals, myAssessments } = this.props;

    const {
      pendingAssessment,
      scoredAssessments,
    } = this.props.user;

    const pendingAssessmentIsInProgress = pendingAssessment && pendingAssessment.status === 'inprogress';

    const name = this.props.user.firstName + ' ' + this.props.user.lastName;
    const organizationId = this.props.user.organizationId;

    const { dealStages, dealIQDisabled, coachingIQDisabled, talentIQDisabled, competenciesEnabled, preserveTalentCards } = this.props.organization || {};

    const showImperativesMenu = route.indexOf('imperatives') !== -1;
    const showStrengthsMenu = route.indexOf('strengths') !== -1;
    const { hoveringNonImperativesPage, hoveringNonStrengthsPage } = this.state;

    const enableDevelopmentPages = !isProduction();

    const hasScoredAssessment = _.find(myAssessments, {status: 'scored'}) ? true : false;

    const activeDeals = _.filter(deals, deal => {
      if(deal.status === 'open'){
        const completion = getDealCompletion(deal);

        //actively working deal
        return completion.active;
      }
      else{
        return false;
      }
    });

    //TODO might need to implement this for nav link macthing
    //https://github.com/ReactTraining/react-router/blob/master/packages/react-router-dom/docs/api/NavLink.md
    /*const navLinkIsActive = ( match, location) => {
      return ...
    }*/

    return (
      <div className={`page-sidebar ${hoveringNonImperativesPage ? 'hovering-non-imperative-page ' : ''} ${hoveringNonStrengthsPage ? 'hovering-non-strengths-page ' : ''} ${showImperativesMenu ? 'showing-imperatives ' : ''} ${showStrengthsMenu ? 'showing-strengths ' : ''}`}>

        {this.renderMessageModal()}

        <div className="sidebar-header">
          <h2>{name}</h2>
        </div>
        <ul className="deals">
          <div className="page-name">Seven Imperatives</div>
          <ul className="deals-list">
            <NavLink exact to={`/imperatives`}>
              <li>Deal Summary</li>
            </NavLink>
            {dealStages &&
              <NavLink exact to={`/imperatives-funnel`}>
                <li>Funnel View</li>
              </NavLink>
            }
            <li className="divider"></li>
            <div className="active-deals-area">
              {_.map(activeDeals, deal => {
                const { _id, name } = deal;
                return(
                  <NavLink
                    key={_id}
                    to={`/imperatives/${_id}`}
                  >
                    <li className="active-deal fs-block">{name}</li>
                  </NavLink>
                )
              })}
            </div>
            <div className="active-deals-area-scroll-indicator"></div>
          </ul>
        </ul>
        <ul className="strengths">
          <div className="page-name">Talent Playbook</div>
          <ul className="deals-list">
            <NavLink exact to={`/strengths`}>
              <li>Play to Your Strengths</li>
            </NavLink>
            {/*<NavLink exact to={`/strengths2`}>
              <li>Another report...</li>
            </NavLink>*/}
          </ul>
        </ul>
        <ul
          className="pages"
          onMouseEnter={() => { this.setState({hoveringNonImperativesPage: true, hoveringNonStrengthsPage: true}); }}
          onMouseLeave={() => { this.setState({hoveringNonImperativesPage: false, hoveringNonStrengthsPage: false}); }}
          >
          {!dealIQDisabled &&
            <React.Fragment>
              <li
                className={`imperatives ${showImperativesMenu ? 'submenu-focused' : ''}`}
                onMouseEnter={() => { this.setState({hoveringNonImperativesPage: false}); }}
                onMouseLeave={() => { this.setState({hoveringNonImperativesPage: true}); }}
                >
                <NavLink to={`/imperatives`}>
                  <div className="page-icon">{getIcon('imperatives')}</div>
                  <div className="page-name">Seven Imperatives</div>
                </NavLink>
              </li>
              <li className="section-divider"></li>
            </React.Fragment>
          }
          {!coachingIQDisabled &&
            <React.Fragment>
              <li>
                <NavLink to="/sprint">
                  <div className="page-icon">{getIcon('sprint')}</div>
                  <div className="page-name">Velocity Sprint</div>
                </NavLink>
              </li>
              <li>
                <NavLink to={`/plan`}>
                  <div className="page-icon">{getIcon('plan')}</div>
                  <div className="page-name">Action Plan</div>
                </NavLink>
              </li>
              {(!competenciesEnabled || preserveTalentCards) &&
                <li style={{...(competenciesEnabled && {opacity: .35})}}>
                  <NavLink to={`/talents`}>
                    <div className="page-icon">{getIcon('talents')}</div>
                    <div className="page-name">Talent Card</div>
                  </NavLink>
                </li>
              }
              {competenciesEnabled &&
                <li>
                  <NavLink to={`/salesCompetencies`}>
                    <div className="page-icon">{getIcon('competencies')}</div>
                    <div className="page-name">Sales Competencies</div>
                  </NavLink>
                </li>
              }
              <li className="section-divider"></li>
            </React.Fragment>
          }
          {scoredAssessments &&
            <li>
              <NavLink to="/strengths">
                <div className="page-icon">{getIcon('know')}</div>
                <div className="page-name">Uncover Your Strengths</div>
                <div className="disabled-info">{getIcon('info-bold')}</div>
              </NavLink>
            </li>
          }

          {/*
          {hasScoredAssessment &&
            <li>
              <NavLink to="/know">
                <div className="page-icon">{getIcon('know')}</div>
                <div className="page-name">Know Your Strengths</div>
              </NavLink>
            </li>
          }

          {hasScoredAssessment &&
            <li>
              <NavLink to="/play">
                <div className="page-icon">{getIcon('play')}</div>
                <div className="page-name">Play to Your Strengths</div>
              </NavLink>
            </li>
          }
          {hasScoredAssessment &&
            <li>
              <NavLink to="/improve">
                <div className="page-icon">{getIcon('improve')}</div>
                <div className="page-name">Improve Your Skills</div>
              </NavLink>
            </li>
          }
          {hasScoredAssessment &&
            <li>
              <NavLink to="/showcase">
                <div className="page-icon">{getIcon('showcase')}</div>
                <div className="page-name">Showcase Your Strengths</div>
              </NavLink>
            </li>
          }
          <li className="section-divider"></li>
          {hasScoredAssessment &&
            <li>
              <NavLink to="/responses">
                <div className="page-icon">{getIcon('responses')}</div>
                <div className="page-name">Review Responses</div>
              </NavLink>
            </li>
          }*/}
          <li>
            <NavLink to="/profile">
              <div className="page-icon">{getIcon('profile')}</div>
              <div className="page-name">View / Edit Profile</div>
            </NavLink>
          </li>
        </ul>

        {pendingAssessment &&
          <div className="sidebar-callout">
            <div className="callout-icon">{getIcon('know')}</div>
            <h6>Talent Assessment {pendingAssessmentIsInProgress ? 'In Progress' : 'Pending'}</h6>
            <a href={`/a/${pendingAssessment.assessmentName}?profile=${pendingAssessment.profileName}`} target="_blank">
              <button className="button primary button-micro">{pendingAssessmentIsInProgress ? 'Resume' : 'Take Now'} {getIcon('external-link')}</button>
            </a>
          </div>
        }
      </div>
    )
  }
}

function mapStateToProps(state, ownProps){
  return {
    user: state.user,
    deals: state.deals.data,
    route: ownProps.location.pathname,
    organization: state.organization.data,
    myAssessments: state.myAssessments.data,
  }
}

export default withRouter(connect(mapStateToProps, {})(EmployeeSidebarNav));



// WEBPACK FOOTER //
// ./src/components/shared/employeeSidebarNav.js